import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {LogoutComponent} from './auth/controllers/logout.component';
import {RedirectingGuard} from './_guards';
import {ReopenLockGuard} from './_guards/reopen-lock.guard';
import {LoginComponent} from './auth/controllers/login.component';
import {ToastModule} from 'primeng/toast';

const routes: Routes = [
    {path: 'login', loadChildren: './auth/auth.module#AuthModule'},
    {path: 'logout', component: LogoutComponent},
    // JS-1396: ReopenLockGuard on a parent, not next to RedirectingGuard - guards of
    // one route all start together, and RedirectingGuard fires sidebar-permissions
    // as soon as it is called. A parent's guard settles before the child's run.
    {path: '', canActivate: [ReopenLockGuard], children: [
        {path: '', canActivate: [RedirectingGuard], component: LoginComponent},
    ]},
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes),
        ToastModule,
    ],
    exports: [RouterModule],
    providers: []
})
export class AppRoutingModule {
}
